import React from 'react'
import {connect} from 'react-redux'
import buscarMapaVeiculoItinerario from '../../actions/mapa-veiculo/buscarMapaVeiculoItinerario'
import Titulo from '../comum/Titulo';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import trocarPoltrona from '../../actions/reserva/trocarPoltrona';
import {groupArrayOfObjects} from '../../util/arraysUtil';
import {showErrorMsg, showSuccessMsg} from '../../util/messagesUtil';

const ModalConfirmacaoAlteracaoPoltrona = ({ alterarPoltrona, reserva, poltrona }) => (
  <div className="modal fade" id="modalConfirmacaoAlteracaoPoltrona" tabIndex="-1" role="dialog"
       aria-labelledby="modalConfirmacaoAlteracaoPoltrona" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-body texto-centralizado">
          <p>Confirmar alteração da poltrona do(a) passageiro(a) <strong>{reserva ? reserva.passageiroDto.nome : null}</strong> do número <strong>{reserva ? reserva.numeroPoltrona : null}</strong> para o número <strong>{poltrona ? poltrona.numero : null}</strong>?</p>
        </div>
        <div className="modal-footer ">
          <button id='cancelar' type="button" className="btn btn-outline-secondary"
                  data-dismiss="modal">Não
          </button>
          <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                  onClick={() => alterarPoltrona()}>Sim
          </button>
        </div>
      </div>
    </div>
  </div>);

export class PainelAlteracaoPoltrona extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      reserva: null,
      poltrona: null,
      reservas: props.reservasSelecionadas
    };
  }

  componentDidMount () {
    if (this.state.reservas && this.state.reservas.length) {
      if(Object.entries(groupArrayOfObjects(this.state.reservas, 'itinerarioId')).length > 1){
        showErrorMsg('Não é permitido alterar poltronas de itinerários diferentes');
        this.props.history.push('/painel-remarcacao');
      }
      let reserva = this.state.reservas[0];
      this.props.buscarItinerario(this.props.empresaSelecionada.id, reserva.itinerarioId);
    } else {
      this.props.history.push('/painel-remarcacao');
    }
  }

  selecionarPoltrona (poltrona) {
    this.setState({ poltrona: poltrona })
  }

  montarMapaAssentosVolta () {
    if (this.props.volta) {
      this.props.changeFieldValue('formReserva',
        'embarqueVolta', this.props.volta.embarque);
      this.props.buscarMapaVeiculoItinerario(this.props.volta.idItinerario, this.props.destino.id, this.props.origem.id);
    }
  }

  selecionarReserva(reserva){
    if(this.state.reserva && this.state.reserva.id === reserva.id){
      this.setState({ reserva: null })
    }else{
      this.props.buscarMapaVeiculoItinerario(reserva.itinerarioId, reserva.idCidadeOrigem, reserva.idCidadeDestino, true);
      this.setState({ reserva: reserva })
    }

  }

  renderReserva (reserva, indice) {
    return <li key={`acao${indice}`} className="list-group-item" style={{
      cursor: 'pointer',
      backgroundColor: this.state.reserva && this.state.reserva.id === reserva.id ? '#fa8d42' : ''
    }}
               onClick={() => this.selecionarReserva(reserva)}>
      <span className='ml-2'>{reserva.passageiroDto.nome} - {reserva.numeroPoltrona}</span></li>
  }

  exibirReservas () {
    if (this.state.reservas.length) {
      return <div className="container mt-4">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-header">
                Selecione a reserva
              </div>
              <ul className="list-group list-group-flush">
                {this.state.reservas.map((reserva, index) => this.renderReserva(reserva, index))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    }
  }

  montarMapa () {
    if (this.props.mapaVeiculoItinerarioIda && this.props.mapaVeiculoItinerarioIda.length) {
      return (this.props.mapaVeiculoItinerarioIda.map(fileira =>
        <React.Fragment key={fileira.id}>
          <div>
            {this.exibirFileira(fileira)}
          </div>
          {this.exibirCorredor(fileira)}
        </React.Fragment>))
    }
  }

  exibirCorredor (fileira) {
    return (fileira.exibeCorredor ? <div className="transport-meio-corredor" key={`corredor-${fileira.id}`}/> : '')
  }

  // eslint-disable-next-line class-methods-use-this
  exibirFileira (fileira) {
    if (fileira.assentos.length > 0) {
      return (
        <div className="transport-meio-fileira" key={`fileira-${fileira.numero}-${this.props.andar}`}>
          {this.exibirAssentos(fileira)}
          <label htmlFor="_" className="transport-meio-assento espaco-vago" key='meio6'>_</label>
        </div>
      )
    }
  }

  exibirAssentos (fileira) {
    return fileira.assentos.map(assento => <div key={`assento-${this.props.sentido}-${fileira.numero}-${assento.ordem}`}>
      {this.exibirAssento(assento)}
    </div>)
  }

  alterarPoltrona () {
    const parametros = {
      reservaId: this.state.reserva.id,
      poltronaId: this.state.poltrona.id,
      itinerarioId: this.props.itinerarioSelecionado.id,
      empresaId: this.props.empresaSelecionada.id
    };

    this.props.trocarPoltrona(parametros)
      .then(() => {
          showSuccessMsg('Poltrona alterada com sucesso');
          this.props.buscarMapaVeiculoItinerario(this.state.reserva.itinerarioId, this.state.reserva.idCidadeOrigem, this.state.reserva.idCidadeDestino, true);
          this.setState({reserva: Object.assign({}, this.state.reserva, { numeroPoltrona: this.state.poltrona.numero })})
          let reservas = this.state.reservas.filter(f => f.id !== this.state.reserva.id);
          reservas.push(this.state.reserva)
          this.setState({reservas: reservas})
      })
  }

  exibirAssento (assento) {
    const { poltrona } = assento;
    if (assento.tipoAssento !== 'NORMAL') {
      return <label key={assento.id} className="espaco-vago  js-seat-selected-amplitude"></label>
    }
    if (!poltrona || poltrona.bloqueada) {
      return <label data-toggle="tooltip" data-html="true" key={assento.id} className="assento assento-ocupado" style={{
        backgroundColor: 'red',
        color: '#FFF'
      }}>{poltrona.numero}</label>
    }
    if (!poltrona || poltrona.reservada) {
      return <label data-toggle="tooltip" data-html="true" key={assento.id} className="assento assento-ocupado">{poltrona.numero}</label>
    }
    return (
      <label key={assento.id} style={!assento.selecionado ? {
        backgroundColor: '#02c659',
        color: '#FFF'
      } : null}
             className={`assento assento-disponivel  js-seat-selected-amplitude ${assento.selecionado ? 'assento-selecionado' : ''}`}>
        {poltrona.numero}
        <input type="checkbox" name={poltrona.id} id={poltrona.id} data-assento={poltrona.numero}
               onClick={() => this.selecionarPoltrona(poltrona)}
               data-toggle="modal"
               data-target="#modalConfirmacaoAlteracaoPoltrona"
               value={poltrona.numero}/>

      </label>
    )
  }

  exibirMapa () {
    return <React.Fragment>
      <h3 className='text-center'>Selecione a nova poltrona</h3>
      <div className="transport-result-wrapper transport-result-wrapper-connection " data-wrapper-direction="">
        <div className="js-count-transport">
          <div className="transport bus-design bus-design-side ">
            <div className="transport-frente"/>
            <div className="transport-meio transport-meio-thin">
              {this.montarMapa()}
            </div>
            <div className="transport-traseira"/>
          </div>
        </div>
      </div>
    </React.Fragment>
  }

  render () {
    if (this.state.reservas.length) {
      let reserva = this.state.reservas[0];
      return (
        <div className="row internas">
          <Titulo texto="Alteração de poltrona" urlRetorno="/painel-remarcacao"/>
          <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
            <div className='mt-2 col-md-12'>
              <div className="col-12 titulo-principal-componente">
                <h1 id="titulo-page" className="text-center">{`${reserva.descCidadeOrigem} -> ${reserva.descCidadeDestino}`}</h1>
                <h4 id="titulo-page" className="text-center">Saída {this.props.itinerarioSelecionado.dataHoraPartida} - Chegada {this.props.itinerarioSelecionado.dataHoraChegada}</h4>
              </div>
              {this.exibirReservas()}
              {this.state.reserva ? this.exibirMapa() : ''}
            </div>
          </div>
          <ModalConfirmacaoAlteracaoPoltrona alterarPoltrona={this.alterarPoltrona.bind(this)} reserva={this.state.reserva} poltrona={this.state.poltrona}/>
        </div>
      )
    }
    return '';
  }
}


export const mapStateToProps = state => (
  {
    poltronasSelecionadas: state.poltronasSelecionadas,
    mapaVeiculoItinerarioIda: state.mapaVeiculoItinerarioIda,
    reservasSelecionadas: state.remarcacao.reservasSelecionadas,
    itinerarioSelecionado: state.itinerarioSelecionado,
    empresaSelecionada: state.empresaSelecionada

  });


export default connect(mapStateToProps,
  {
    buscarMapaVeiculoItinerario,
    buscarItinerario,
    trocarPoltrona
  })(PainelAlteracaoPoltrona)
